import script from "./CallBriefcaseWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./CallBriefcaseWidget.vue?vue&type=script&setup=true&lang=js"

import "./CallBriefcaseWidget.vue?vue&type=style&index=0&id=3b7c5900&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b7c5900"]])

export default __exports__